import { Dispatch, SetStateAction } from "react";
import EstablishmentInterfaceForm from "./EstablishmentInterfaceForm";

const EstablishmentInterfaceEdit = ({
  nextButtonFunction,
  establishmentID,
  interfaceData,
  updateInterfaceData,
  setIsEstablishmentInterfaceInit
}: EstablishmentInterfaceEditProps) => {

  const initialValues: IEstablishmentInterfaceIDForm = {
    interfaceID: interfaceData.interfaceID
  }


  const handleSubmit = async (values: IEstablishmentInterfaceIDForm) => {
    updateInterfaceData(values);
    setIsEstablishmentInterfaceInit(true);
    nextButtonFunction();
  };
  
  return (
    <>
      
        <EstablishmentInterfaceForm 
          type={"edit"} 
          initialValues={initialValues} 
          onSubmit={handleSubmit}    
        />
       
    </>
    
  )
}

export default EstablishmentInterfaceEdit;

type EstablishmentInterfaceEditProps = {
  nextButtonFunction: () => void;
  establishmentID?: number;
  interfaceData: IEstablishmentInterfaceForm;
  setIsEstablishmentInterfaceInit: Dispatch<SetStateAction<boolean>>;
  updateInterfaceData: (data: Partial<IEstablishmentInterfaceForm>) => void;
}